module.exports = __webpack_public_path__ + "static/media/LogoDrivee.156067d5.jpg";